import { z } from 'zod';
import { DocId, IsoTimestamp } from '../common.js';
/**
 * Per-user video playback state — drives Continue Watching on the library
 * and resume-on-open on the detail page.
 *
 * Firestore path: `users/{userId}/video_progress/{videoId}` (NOT under
 * tenants/ — matches the chat-history pattern documented in memory under
 * `daily_user_activity_report.md`). Documented exception under Hard Rule
 * #1 in CLAUDE.md.
 *
 * Idempotent — the client posts the current playhead every ~10s while
 * playing; the server overwrites the record. `percentComplete` is computed
 * server-side from `positionSeconds / durationSeconds` so the client can't
 * mark a video complete by sending a bogus percentage.
 */
export const VideoProgress = z.object({
    videoId: DocId,
    lastPositionSeconds: z.number().nonnegative(),
    percentComplete: z.number().min(0).max(1),
    lastWatchedAt: IsoTimestamp,
});
export const UpdateVideoProgressBody = z.object({
    positionSeconds: z.number().nonnegative(),
    /** Client passes this so the server can compute percentComplete safely. */
    durationSeconds: z.number().positive(),
});
//# sourceMappingURL=video-progress.js.map